import React from 'react';
import PropTypes from 'prop-types';
import { Badge, BadgeLeft, BadgeRight, SinglePill, Icon, Text } from './styled';

const GROUP_BY_LABELS = {
  name: 'NAME',
  cve: 'CVE',
  external_id: 'EXTERNAL ID',
  none: 'NONE'
};

const normalize = (v) => String(v ?? '').trim().toLowerCase();

const GroupingBadge = ({ vuln, onClick }) => {
  const isGrouped = vuln?.is_automatic !== null && typeof vuln?.is_automatic !== 'undefined';
  if (!isGrouped) return null;

  const groupTitle = String(vuln?.group_title ?? '').trim();
  if (!groupTitle) return null;

  const isAutomatic = vuln?.is_automatic === true;

  // criterio (left)
  const groupByRaw = normalize(vuln?.group_by);
  const criterionLabel = groupByRaw
    ? (GROUP_BY_LABELS[groupByRaw] ?? groupByRaw.toUpperCase())
    : null;

  // MANUAL: una sola pill, sin parte oscura
  if (!isAutomatic) {
    return (
      <SinglePill title={ `Manual group: ${groupTitle}` } onClick={ onClick }>
        <Icon aria-hidden="true" />
        <Text>{groupTitle}</Text>
      </SinglePill>
    );
  }

  // AUTO: split pill (left criterio, right valor)
  // Si por alguna razón no hay criterio, mostramos "AUTO" a la izquierda
  const left = criterionLabel ?? 'AUTO';

  return (
    <Badge
      title={ `Automatic group by ${left}: ${groupTitle}` }
      onClick={ onClick }
    >
      <BadgeLeft>
        <Icon aria-hidden="true" />
        <Text>{left}</Text>
      </BadgeLeft>

      <BadgeRight>
        <Text>{groupTitle}</Text>
      </BadgeRight>
    </Badge>
  );
};

GroupingBadge.propTypes = {
  vuln: PropTypes.shape({
    is_automatic: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
    group_title: PropTypes.string,
    group_by: PropTypes.string
  }),
  onClick: PropTypes.func
};

GroupingBadge.defaultProps = {
  vuln: null,
  onClick: () => {}
};

export default GroupingBadge;
